module.exports = "<div class=\"side-panel-wrap\" ng-transclude></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpSidePanel/adpSidePanel.html
// module id = 453
// module chunks = 0